import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  getStudent,
  getStudents,
  getAllStudents,
  updateStudent,
  updatePassword,
} from '../api/students.api';
import {
  IStudent,
  IStudentItem,
  IGetStudent,
  IGetStudents,
  IStudentParams,
  IPasswordReq,
} from '../models/students.model';

interface IStudentState {
  student?: IStudent;
  students?: IStudentItem[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IStudentState = {
  student: undefined,
  students: [],
  isLoading: false,
};

const studentSlicer = createSlice({
  name: 'student',
  initialState,
  reducers: {
    getStudentStart: (state: IStudentState) => {
      state.student = undefined;
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentSuccess: (
      state: IStudentState,
      action: PayloadAction<IGetStudent>,
    ) => {
      state.student = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentFailure: (
      state: IStudentState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.student = undefined;
      state.isLoading = false;
      state.error = action.payload;
    },
    getStudentsStart: (state: IStudentState) => {
      state.students = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentsSuccess: (
      state: IStudentState,
      action: PayloadAction<IGetStudents>,
    ) => {
      state.students = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentsFailure: (
      state: IStudentState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.students = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IStudentState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IStudentState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // createSuccess: (state: IStudentState) => {
    //   state.isLoading = false;
    //   state.error = undefined;
    // },
    updateSuccess: (state: IStudentState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    // deleteSuccess: (state: IStudentState) => {
    //   state.isLoading = false;
    //   state.error = undefined;
    // }
  },
});

export const {
  getStudentStart,
  getStudentSuccess,
  getStudentFailure,
  getStudentsStart,
  getStudentsSuccess,
  getStudentsFailure,
  requestStart,
  requestFailure,
  // createSuccess,
  updateSuccess,
  // deleteSuccess
} = studentSlicer.actions;

export default studentSlicer.reducer;

export const doGetStudent =
  (memberCode: string, campusCode: string): any =>
  async (dispatch: any) => {
    try {
      dispatch(getStudentStart());
      const response = await getStudent(memberCode, campusCode);
      dispatch(getStudentSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(getStudentFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doGetStudents = (params: IStudentParams): any => async (dispatch: any) => {
    try {
      dispatch(getStudentsStart());
      const response = await getStudents(params);
      dispatch(getStudentsSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(getStudentsFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doGetAllStudents = (): any => async (dispatch: any) => {
  try {
    dispatch(getStudentsStart());
    const response = await getAllStudents();
    dispatch(getStudentsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getStudentsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

// export const doCreateStudent = (campusId: string, data: IStudentReq): any => async (dispatch: any) => {
//   try {
//     dispatch(requestStart());
//     const response = await createStudent(campusId, data);
//     dispatch(createSuccess());
//     return response;
//   } catch (e: any) {
//     dispatch(requestFailure(e.response?.data?.data || e.message));
//     return e.response;
//   }
// };

export const doUpdateStudent =
  (studentCode: string, campusCode: string, data: any): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await updateStudent(studentCode, campusCode, data);
      dispatch(updateSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doUpdatePassword =
  (data: IPasswordReq): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await updatePassword(data);
      dispatch(updateSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

// export const doDeleteStudent = (id: string): any => async (dispatch: any) => {
//   try {
//     dispatch(requestStart());
//     const response = await deleteStudent(id);
//     dispatch(deleteSuccess());
//     return response;
//   } catch (e: any) {
//     dispatch(requestFailure(e.response?.data?.data || e.message));
//     return e.response;
//   }
// };
